import { clsx } from "clsx";

export type TypographyProps = {
  color?: "black" | "gray" | "white";
  size?: "2xs" | "xs" | "sm" | "base" | "lg";
  leading?: "default" | "loose";
  withHeadings?: boolean;
} & ({ children: React.ReactNode } | { dangerouslySetInnerHTML: { __html: string } });

export function Typography({
  color = "black",
  size = "base",
  leading = "default",
  withHeadings = true,
  ...props
}: TypographyProps) {
  return (
    <div
      style={
        {
          "--em": `var(--tw-font-size-${size})`,
          "--lh":
            leading === "loose"
              ? `var(--tw-line-height-${size}-loose, var(--tw-line-height-${size}))`
              : `var(--tw-line-height-${size})`,
          "--trim-top":
            leading === "loose"
              ? `var(--tw-trim-top-${size}-loose, var(--tw-trim-top-${size}))`
              : `var(--tw-trim-top-${size})`,
          "--trim-bottom":
            leading === "loose"
              ? `var(--tw-trim-bottom-${size}-loose, var(--tw-trim-bottom-${size}))`
              : `var(--tw-trim-bottom-${size})`,
        } as React.CSSProperties
      }
      className={clsx(
        "typography",
        leading === "loose" && "typography-loose",
        withHeadings && "typography-headings",
        color === "gray" && "typography-gray",
        color === "white" && "typography-white",
      )}
      {...props}
    />
  );
}
